import React from 'react'; // これ追加!
import { createRoot } from 'react-dom/client';
import App from './App';

/**
 * WordPressページにReactアプリをマウント
 */
const rootElement = document.getElementById('gy__innerReact');
if (rootElement) {
    const root = createRoot(rootElement);
    root.render(<App />);
}